import abilities from "@/i18n/abilities"
import adversaries from "@/i18n/adversaries"
import createPassword from "@/i18n/auth/create-password"
import forgotPassword from "@/i18n/auth/forgot-password"
import mfa from "@/i18n/auth/mfa"
import signin from "@/i18n/auth/signin"
import backend from "@/i18n/general/backend"
import general from "@/i18n/general/general"
import list from "@/i18n/general/list"
import navbar from "@/i18n/layout/navbar"
import pagination from "@/i18n/layout/pagination"
import user from "@/i18n/layout/user"
import userMenu from "@/i18n/layout/user-menu"
import userProfileTeamMembers from "@/i18n/layout/user-profile-team-members"
import userProfiles from "@/i18n/layout/user-profiles"
import objectives from "@/i18n/objectives"
import operations from "@/i18n/operations"
import sources from "@/i18n/sources"
import requestError from "@/i18n/warnings/request-error"
import valueError from "@/i18n/warnings/value-error"
import validators from "@/i18n/yup/validators"
import agents from "@/i18n/agents"
import userProfilesColors from "@/i18n/layout/userProfilesColors"
import support from "@/i18n/support"
import dashboard from "@/i18n/dashboard"
import tenants from "@/i18n/tenants"
import contents from "@/i18n/contents"
import facts from "@/i18n/facts"
import rules from "@/i18n/rules"
import variables from "@/i18n/variables"
import reports from "@/i18n/reports"
import assessments from "@/i18n/assessments"

const messages = {
  en: {
    general: general.en,
    createPassword: createPassword.en,
    signin: signin.en,
    mfa: mfa.en,
    validators: validators.en,
    valueError: valueError.en,
    requestError: requestError.en,
    navbar: navbar.en,
    user: user.en,
    userMenu: userMenu.en,
    userProfiles: userProfiles.en,
    backend: backend.en,
    forgotPassword: forgotPassword.en,
    userProfileTeamMembers: userProfileTeamMembers.en,
    userProfilesColors: userProfilesColors.en,
    pagination: pagination.en,
    abilities: abilities.en,
    adversaries: adversaries.en,
    agents: agents.en,
    objectives: objectives.en,
    sources: sources.en,
    operations: operations.en,
    list: list.en,
    support: support.en,
    dashboard: dashboard.en,
    tenants: tenants.en,
    contents: contents.en,
    facts: facts.en,
    rules: rules.en,
    reports: reports.en,
    variables: variables.en,
    assessments: assessments.en
  },
  pt: {
    general: general.pt,
    createPassword: createPassword.pt,
    signin: signin.pt,
    mfa: mfa.pt,
    validators: validators.pt,
    valueError: valueError.pt,
    requestError: requestError.pt,
    navbar: navbar.pt,
    user: user.pt,
    userMenu: userMenu.pt,
    userProfiles: userProfiles.pt,
    userProfileTeamMembers: userProfileTeamMembers.pt,
    backend: backend.pt,
    userProfilesColors: userProfilesColors.pt,
    pagination: pagination.pt,
    abilities: abilities.pt,
    forgotPassword: forgotPassword.pt,
    adversaries: adversaries.pt,
    agents: agents.pt,
    objectives: objectives.pt,
    sources: sources.pt,
    operations: operations.pt,
    list: list.pt,
    support: support.pt,
    dashboard: dashboard.pt,
    tenants: tenants.pt,
    contents: contents.pt,
    facts: facts.pt,
    rules: rules.pt,
    reports: reports.pt,
    variables: variables.pt,
    assessments: assessments.pt
  },
  es: {
    general: general.es,
    createPassword: createPassword.es,
    signin: signin.es,
    mfa: mfa.es,
    validators: validators.es,
    valueError: valueError.es,
    requestError: requestError.es,
    navbar: navbar.es,
    user: user.es,
    userMenu: userMenu.es,
    userProfiles: userProfiles.es,
    userProfileTeamMembers: userProfileTeamMembers.es,
    backend: backend.es,
    userProfilesColors: userProfilesColors.es,
    forgotPassword: forgotPassword.es,
    pagination: pagination.es,
    abilities: abilities.es,
    adversaries: adversaries.es,
    agents: agents.es,
    objectives: objectives.es,
    sources: sources.es,
    operations: operations.es,
    list: list.es,
    support: support.es,
    dashboard: dashboard.es,
    tenants: tenants.es,
    contents: contents.es,
    facts: facts.es,
    rules: rules.es,
    reports: reports.es,
    variables: variables.es,
    assessments: assessments.es
  }
}

export default messages
